<ng-template #modal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{modalContent?.name}}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-system-loader [loader]="isLoading"></app-system-loader>
    <form [formGroup]="form" (ngSubmit)="sendFile()" *ngIf="!isLoading" class="table-form">
      <div class="form-group row m-b">
        <div class="col-sm-12">
          <label class="col-sm-12 pb-1">Selecione CSV para upload</label>
          <input type="file" id="file" class="form-control" formControlName="file" (change)="onFileSelected($event)" required />
          <app-field-message [field]="fieldMessageRequired('file')" [erros]="fieldErros('file')"></app-field-message>
        </div>
      </div>

      <div class="form-group row col-sm-4">
        <a href="assets/files/{{modalContent?.file}}" download="importacao-exemplo" target="_blank">Baixar exemplo</a>
      </div>

      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="closeModal()">Voltar</button>
          <button class="btn btn-primary" type="submit">Salvar</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>